/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DividendPaymentNotificationPayloadDto,
    DividendPaymentNotificationPayloadDtoFromJSON,
    DividendPaymentNotificationPayloadDtoFromJSONTyped,
    DividendPaymentNotificationPayloadDtoToJSON,
} from './DividendPaymentNotificationPayloadDto';

/**
 * 
 * @export
 * @interface DividendPaymentNotificationDto
 */
export interface DividendPaymentNotificationDto {
    /**
     * 
     * @type {string}
     * @memberof DividendPaymentNotificationDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DividendPaymentNotificationDto
     */
    portfolioId: string;
    /**
     * 
     * @type {string}
     * @memberof DividendPaymentNotificationDto
     */
    portfolioName: string;
    /**
     * 
     * @type {Date}
     * @memberof DividendPaymentNotificationDto
     */
    eventAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof DividendPaymentNotificationDto
     */
    readAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof DividendPaymentNotificationDto
     */
    createdAt: Date;
    /**
     * 
     * @type {string}
     * @memberof DividendPaymentNotificationDto
     */
    type: string;
    /**
     * 
     * @type {DividendPaymentNotificationPayloadDto}
     * @memberof DividendPaymentNotificationDto
     */
    payload: DividendPaymentNotificationPayloadDto;
}

export function DividendPaymentNotificationDtoFromJSON(json: any): DividendPaymentNotificationDto {
    return DividendPaymentNotificationDtoFromJSONTyped(json, false);
}

export function DividendPaymentNotificationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DividendPaymentNotificationDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'portfolioId': json['portfolioId'],
        'portfolioName': json['portfolioName'],
        'eventAt': (new Date(json['eventAt'])),
        'readAt': (json['readAt'] === null ? null : new Date(json['readAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'type': json['type'],
        'payload': DividendPaymentNotificationPayloadDtoFromJSON(json['payload']),
    };
}

export function DividendPaymentNotificationDtoToJSON(value?: DividendPaymentNotificationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'portfolioId': value.portfolioId,
        'portfolioName': value.portfolioName,
        'eventAt': (value.eventAt.toISOString()),
        'readAt': (value.readAt === null ? null : value.readAt.toISOString()),
        'createdAt': (value.createdAt.toISOString()),
        'type': value.type,
        'payload': DividendPaymentNotificationPayloadDtoToJSON(value.payload),
    };
}

